import isFunction from 'lodash/isFunction'
import { ReactNodeOrNull } from './renderIf'
import { AnyReactComponentType } from './types'

type RenderSwitchConditionType = {
  condition: boolean
  component: AnyReactComponentType | ReactNodeOrNull
}

/*
 switch-style version of renderIf.  Just like a switch statement, the first condition in the list of conditions
 which is true will be rendered
 @param conditions - an array of objects with these members:
 condition: a boolean value indicating whether this condition is active
 component: a component or function which renders component(s) to render if the condition is active
 @param defaultComponent - a component or function which renders component(s) to render if no conditions are active
 */
export const renderSwitch = (
  conditions: Array<RenderSwitchConditionType>,
  defaultComponent: AnyReactComponentType | ReactNodeOrNull = null
): ReactNodeOrNull => {
  const matchingComponent = conditions.reduce(
    (_matchingComponent, conditionCur) => {
      const { condition, component } = conditionCur
      if (!_matchingComponent && condition) {
        _matchingComponent = component
      }
      return _matchingComponent
    },
    null as AnyReactComponentType | ReactNodeOrNull
  )
  if (!matchingComponent)
    return isFunction(defaultComponent)
      ? defaultComponent({})
      : (defaultComponent as ReactNodeOrNull)
  return isFunction(matchingComponent)
    ? matchingComponent({})
    : (matchingComponent as ReactNodeOrNull)
}

export default renderSwitch
